export default [
  { "name": "expand_circle_down", "code": "e7cd" },
  { "name": "star", "code": "e838" },
  { "name": "stars", "code": "e8d0" },
  { "name": "military_tech", "code": "ea3f" },
  { "name": "hotel_class", "code": "e743" },
  { "name": "cancel", "code": "e5c9" },
  { "name": "wrong_location", "code": "ef78" },
  { "name": "add_circle", "code": "e147" },
  { "name": "check_circle", "code": "e86c" },
  { "name": "block", "code": "e14b" },
  { "name": "arrow_circle_down", "code": "f181" },
  { "name": "pin_drop", "code": "e55e" },
  { "name": "location_on", "code": "e0c8" },
  { "name": "flag", "code": "e153" },
  { "name": "sports_score", "code": "f06e" },
  { "name": "tour", "code": "ef75" },
  { "name": "golf_course", "code": "eb45" },
  { "name": "person_pin_circle", "code": "e56a" },
  { "name": "where_to_vote", "code": "e177" },
  { "name": "share_location", "code": "f05f" },
  { "name": "local_police", "code": "ef56" },
  { "name": "add_location_alt", "code": "ef3a" },
  { "name": "add_location", "code": "e567" },
  { "name": "south", "code": "f1e3" },
  { "name": "crisis_alert", "code": "ebe9" },
  { "name": "local_atm", "code": "e53e" },
  { "name": "flag_circle", "code": "eaf8" },
  { "name": "arrow_drop_down", "code": "e5c5" },
  { "name": "fmd_bad", "code": "f00e" },
  { "name": "local_pizza", "code": "e552" },
  { "name": "not_listed_location", "code": "e575" },
  { "name": "location_off", "code": "e0c7" },
  { "name": "edit_location", "code": "e568" },
  { "name": "mode_of_travel", "code": "e7ce" },
  { "name": "edit_location_alt", "code": "e1c5" },
  { "name": "sos", "code": "ebf7" },
  { "name": "compass_calibration", "code": "e57c" },
  { "name": "opacity", "code": "e91c" },
  { "name": "brightness_1", "code": "e3a6" },
  { "name": "invert_colors_off", "code": "e0c4" },
  { "name": "report", "code": "e160" },
  { "name": "person", "code": "e7fd" },
  { "name": "man", "code": "e4eb" },
  { "name": "woman", "code": "e13e" },
  { "name": "reorder", "code": "e8fe" },
  { "name": "vertical_align_bottom", "code": "e258" },
  { "name": "directions_car", "code": "e531" },
  { "name": "apartment", "code": "ea40" },
  { "name": "location_city", "code": "e7f1" },
  { "name": "home", "code": "e88a" },
  { "name": "arrow_circle_up", "code": "f182" },
  { "name": "add_task", "code": "f23a" },
  { "name": "bolt", "code": "ea0b" },
  { "name": "flash_on", "code": "e3e7" },
  { "name": "electric_bolt", "code": "ec1c" },
  { "name": "radio_button_checked", "code": "e837" },
]
